import React, { ReactElement, lazy } from 'react';
import './styles-overrides.css';
import { ParentProvider } from '@paypalcorp/pp-com-ui/components/ParentProvider';
import { CMSPage } from '@paypalcorp/cms-engine/components';
import { NavFragment } from '@paypalcorp/globalnavsdk/NavFragment';
import { RegionalBannerFragment } from '@paypalcorp/regionalbannersdk/RegionalBannerFragment';
import { overrideEntryPathForMPP } from '../../utils/commonUtils';
import { RegularFooter } from '../components/RegularFooter';
import { CustomAppProps } from '../types/appTypes';

export default function App({
  renderContext,
}: Readonly<CustomAppProps>) {
  const {
    componentKit, pageContext, pageModel, ...props
  } = renderContext;

  const ComponentsMap: Record<string, ReactElement | any> = {};
  Object.keys(componentKit).forEach((key) => {
    ComponentsMap[key] = componentKit[key]?.bundle || lazy(() => import(`../../../node_modules/@paypalcorp/pp-com-ui/dist/components/${key}.js`));
  });

  const {
    cmsEngineContext: {
      environment: {
        isRTL = false,
      } = {},
    } = {},
  } = pageContext;

  return (
    <CMSPage
      data-testid="cms-page"
      componentKit={{
        Parent: ParentProvider,
        ...ComponentsMap,
      }}
      dir={isRTL ? 'rtl' : 'ltr'}
      hostedBy="ppcmsnodeweb"
      pageContext={overrideEntryPathForMPP(pageContext)}
      pageModel={pageModel}
      {...props}
      render={({
        aboveHeader, body, belowFooter,
      }) => (
        <>
          <RegionalBannerFragment />
          {aboveHeader}
          <NavFragment type="header" />
          <main className="document-body">
            {body}
            {belowFooter}
          </main>
          <RegularFooter />
        </>
      )}
    />
  );
}
